import { PROFILES } from "../../../enums/PROFILES.enum";
import axiosInstance from "../../axiosInstance";
import { UsersListResponse } from "./select.interface";

export const selectLayout = async (
  perfilId: number,
  idAssessor: number,
  isSetorCorregedoria?: boolean,
): Promise<UsersListResponse> => {
  let endpoint: string;
  let loadCurrentUser = false;
  switch (perfilId) {
    case PROFILES.ANALISTA:
      endpoint = `/api/v1.0/procuradores?pageSize=250`;
      break;

    case PROFILES.ASSESSOR_PROCURADOR:
    case PROFILES.ASSESSOR_DE_PROCURADOR:
    case PROFILES.OPERADOR_ASSESSOR_DO_PROCURADOR:
      endpoint = `/api/v1.0/assessores/${idAssessor}/procuradores`;
      break;

    case PROFILES.PROCURADOR:
      if (isSetorCorregedoria) {
        // REGRA NOVA: Corregedoria vê TODOS os procuradores
        endpoint = `/api/v1.0/procuradores?pageSize=250`;
      } else {
        // comportamento antigo
        endpoint = `/api/v1.0/assessores/${idAssessor}/procuradores`;
      }
      break;
  }

  const { data } = await axiosInstance.get(endpoint);

  return data;
};
